export const deClientPortalAssetPreview = {
    ratings: {
        locationQuality: 'Lagequalität',
        assetQuality: 'Objektqualität',
        rentalSituation: 'Vermietungssituation',
    },
}
